import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { tConst } from "../../utils/constantsTranslator";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import Select from "react-select";
import {
  getCommonSearchList,
  getSettingsCompanyDetails,
} from "../../services/settingsServices";
import ConfigDB from "../../config";
import ReactPaginate from "react-paginate";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createConvertPart,
  createOCRreferenceRead,
  createPartsCheckDamage,
  createPartsCheckImage,
  createPartsCheckReferenceCheck,
  createPartsCheckVideo,
  deletePartsCheckImage,
  deletePartsCheckVideo,
  getChangePartCheckStatus,
  getDismentalAllPartsCheckStatus,
  getPartCatalogSerachCheck,
  getPartCheckDetails,
  getPartEstimatePriceDetails,
  getPartRefcodeConditionDetails,
  getPartsByReference,
  getStructureOem,
  getvehicleCompatibleProduct,
  getvehicleProductDetails,
  partInvenoryPartETAI,
} from "../../services/PartsInventory";
import { toast } from "react-toastify";
import Utils from "../../utils";
import ReactStars from "react-rating-stars-component";
import { profileDetailForWeb } from "../../services/AuthServices";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { ReactSketchCanvas } from "react-sketch-canvas";
import Card from "react-bootstrap/Card";
import moment from "moment";
import { getDismentalList } from "../../services/DismentalServices";

const PartsCheck = ({ setActiveTab, vehicleProcessList, vehicleId }) => {
  const { t } = useTranslation();
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const LangData = localStorage.getItem("lng");
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const [vehiclePartCheckData, setVehiclePartCheckData] = useState({});
  const [dismentalData, setDismentalData] = useState({
    dismantle_id: "",
    part_check_status: 0,
    is_part_converted: 0,
  });

  const [vehiclePartsManagementList, setVehiclePartsManagementList] = useState(
    [],
  );
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    vehicle_id: vehicleProcessList?.vehicle_id
      ? vehicleProcessList?.vehicle_id
      : vehicleId,
    vehicle_type_id: 0,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [partCheckStatusList, setPartCheckStatusList] = useState([]);
  const [partCheckModal, setPartCheckModal] = useState(false);
  const [activePartTab, setActivePartTab] = useState("references");
  const [partsCheckData, setPartsCheckData] = useState({
    vehicle_id: "",
    part_catalog_id: "",
    parts_reference: [],
    parts_damage: [],
    parts_reference_label: [],
  });

  const [conditionList, setConditionList] = useState([]);
  const [referenceList, setReferenceList] = useState([]);
  const [selectedReferenceCode, setSelectedReferenceCode] = useState("");
  const [selectedBrandCode, setSelectedBrandCode] = useState("");
  const [selectedManufacterCode, setSelectedManufacterCode] = useState("");

  const [selectedDamageDescription, setSelectedDamageDescription] =
    useState("");

  const [selectedCondition, setSelectedCondition] = useState(
    conditionList.find((item) => item.value === 1) || {
      value: 1,
      label: "OEM",
    },
  );
  const [selectedType, setSelectedType] = useState(
    referenceList.find((item) => item.value === 2) || {
      value: 2,
      label: "Written on the label",
    },
  );

  const [partId, setPartId] = useState("");
  const [etaiPartId, setEtaiPartId] = useState("");

  const [typeDamageList, setTypeDamageList] = useState([]);
  const [locationDamageList, setLocationDamageList] = useState([]);
  const [selectedTypeDamage, setSelectedTypeDamage] = useState({
    value: null,
    type: "",
  });
  const [selectedLocation, setSelectedLocation] = useState({
    value: null,
    type: "",
  });
  const [selectedDamageRating, setSelectedDamageRating] = useState(0);
  const [modalOcrRef, setModalOcrRef] = useState(false);
  const [file, setFile] = useState(null);
  let errorsObjImport = {
    file: "",
  };
  const [errorsImport, setErrorsImport] = useState(errorsObjImport);
  const [loading, setLoading] = useState(false);
  const [refReadData, setRefReadData] = useState([]);
  const [updatedTexts, setUpdatedTexts] = useState({});
  const [selectedRows, setSelectedRows] = useState({});
  const [selectedData, setSelectedData] = useState([]);
  const [selectedConditions, setSelectedConditions] = useState({});
  const [selectedReferenceType, setSelectedReferenceType] = useState({});
  const [modalRefCodeCondition, setModalRefCodeCondition] = useState(false);
  const [refCodeConditionDataList, setRefCodeConditionDataList] = useState([]);
  const [modalRefCodeEstimate, setModalRefCodeEstimate] = useState(false);
  const [profileDetails, setProfileDetails] = useState("");
  const [estimatePricDataRefList, setEstimatePricDataRefList] = useState([]);
  const [partETAIRefDetails, setPartETAIRefDetails] = useState([]);
  const [partETAIRerList, setPartETAIRerList] = useState("");
  const [partEtaiModify, setPartEtaiModify] = useState(false);
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  const [modifyOemModal, setModifyOemModal] = useState(false);
  const [loadingStructureOem, setLoadingStructureOem] = useState(false);
  const [selectedVehicleData, setSelectedVehicleData] = useState({
    iem_list: [],
    oem_list: [],
    vehicle_compatible_list: [],
  });
  const [structureOemList, setStructureOemList] = useState([]);
  const [activeOemTab, setActiveOemTab] = useState("1");
  const [modifyConfirmModal, setModifyConfirmModal] = useState(false);
  const [loadingCompatible, setLoadingCompatible] = useState(false);
  const [selectedOEMIndices, setSelectedOEMIndices] = useState([]);
  const [productVehicleId, setProductVehicleId] = useState([]);
  const [modifyProductModal, setModifyProductModal] = useState(false);
  const [vehicleSelectedComDataList, setVehicleSelectedComDataList] = useState(
    [],
  );
  const [vehicleCompatibleProductList, setVehicleCompatibleProductList] =
    useState([]);
  const [vehicleCompatibleProductDetails, setVehicleCompatibleProductDetails] =
    useState([]);
  const [partCheckDetails, setPartCheckDetails] = useState("");
  const [images, setImage] = useState([]);
  const [previewUrl, SetPreviewUrl] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [rotation, setRotation] = useState(0);
  const canvasRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const imgRef = useRef(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [crop, setCrop] = useState({ unit: "%", width: 50, height: 50 });
  const [highlights, setHighlights] = useState([]);
  const [selectedColor, setSelectedColor] = useState("#ff0000");
  const [isCropping, setIsCropping] = useState(false);
  const [enlargedIndexes, setEnlargedIndexes] = useState([]);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  const [isLoadingColor, setIsLoadingColor] = useState(false);
  const [videos, setVideos] = useState([]);
  const fileInputRefs = useRef({});
  const [isModalVideoDelete, setIsModalVideoDelete] = useState(false);
  const [videoDataId, setvideoDataId] = useState("");
  const [isloadingVideo, setIsloadingVideo] = useState(false);
  const [isloadingImage, setIsloadingImage] = useState(false);
  const [isloadingDamage, setIsloadingDamage] = useState(false);
  const [modifyConvert, setModifyConvert] = useState(false);
  const [convertPartId, setConvertPartId] = useState(false);
  const [modalStateRefHistory, setModalStateRefHistory] = useState(false);
  const [catalogModalStateRefDataList, setCatalogModalStateRefDataList] =
    useState([]);
  const [partAddDetails, setPartAddDetails] = useState("");
  const [modalPartDetails, setModalPartDetails] = useState(false);
  const [partDetailsId, setPartDetailsId] = useState(false);
  const [DismetalList, setDismetalList] = useState([]);
  const [inputSelctedDismetalValue, setInputSelctedDismetalValue] =
    useState("");

  const [loadingDismental, setLoadingDismental] = useState(false);

  const handlePartDetailsClose = () => {
    setModalPartDetails(false);
  };
  const handlePartDetailsOpen = (e, item) => {
    setPartDetailsId(item.id);
    setModalPartDetails(true);
  };

  const handleConvertClose = () => {
    setModifyConvert(false);
  };

  const handleConvertPartOpen = (e, item) => {
    setConvertPartId(item?.id);

    setModifyConvert(true);
  };

  const toggleOemTab = (tab) => {
    if (activeOemTab !== tab) setActiveOemTab(tab);
  };

  const vehicleCompatiblesList =
    vehicleCompatibleProductList?.length > 0
      ? vehicleCompatibleProductList
      : structureOemList?.decode?.vehiclesCompatibles || [];

  const handleProductDetailsModalClose = () => {
    setModifyProductModal(false);
  };

  const handleProductConfirmClose = () => {
    setModifyConfirmModal(false);
  };

  const handleCompatibleCheck = (variantID) => {
    const isSelected = selectedVehicleData?.vehicle_compatible_list?.some(
      (item) => item.variantID === variantID,
    );

    const selectedItem = vehicleCompatiblesList.find(
      (item) => item.variantID === variantID,
    );

    if (!selectedItem) return;

    setSelectedVehicleData((prev) => {
      const currentList = prev?.vehicle_compatible_list || [];

      return {
        ...prev,
        vehicle_compatible_list: isSelected
          ? currentList.filter((item) => item.variantID !== variantID)
          : [...currentList, selectedItem],
      };
    });
  };

  const handleSubmitVehicleComProduct = (e) => {
    const selectedProductIds = selectedVehicleData.iem_list
      ?.map((item) => item.productID)
      .join(",");
    let data = {
      productID: selectedProductIds,
      language: LangData ? LangData : "PT",
      country: profileDetails?.company_details?.state,
      regNumberCompany:
        profileDetails?.company_details?.company_registration_number,
    };
    setLoadingCompatible(true);
    getvehicleCompatibleProduct(data)
      .then((response) => {
        setVehicleCompatibleProductList(response.data.data);
        setActiveOemTab("3");
        setModifyConfirmModal(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingCompatible(false);
      });
  };

  const handleEtaiDetails = (event) => {
    event.preventDefault();
    setPartETAIRerList(etaiPartId);
    setPartEtaiModify(true);
  };

  const handlePartEtaiClose = () => {
    setPartEtaiModify(false);
  };

  const handleRadioChange = (referenceCode) => {
    setSelectedReferenceCode(referenceCode);
  };

  const handleOpenRefCodeEstimate = (e) => {
    const data = {
      regNumberCompany:
        profileDetails?.company_details?.company_registration_number,
      language: LangData ? LangData : "EN",

      references: partsCheckData?.parts_reference_label?.map((item) => ({
        reference: item.reference_code,
        referenceType: item.condition_name,
      })),
    };

    getPartEstimatePriceDetails(data)
      .then((response) => {
        setEstimatePricDataRefList(response.data.data.stats);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
    setModalRefCodeEstimate(true);
  };

  const handleCloseRefCodeEstimate = () => {
    setModalRefCodeEstimate(false);
  };

  const handleOpenRefCodeCondition = (e) => {
    setModalRefCodeCondition(true);
  };

  const handleCloseRefCodeCondition = () => {
    setModalRefCodeCondition(false);
  };

  const handleChangeOCROpen = () => {
    setModalOcrRef(true);
  };

  const handleChangeOCRClose = () => {
    setModalOcrRef(false);
  };

  const toggleTab = (tab) => {
    if (activePartTab !== tab) setActivePartTab(tab);
  };

  const handlePartCheckModalClose = () => {
    setPartCheckModal(false);
  };

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
    }

    setParams(paramsObj);
  };

  useEffect(function () {
    var obj = {
      search: "",
      limit: tableLengthList[0],
      page: 1,
    };

    getDismentalList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
        setDismetalList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeDismetalList = (inputSelctedDismetalValue) => {
    setInputSelctedDismetalValue(inputSelctedDismetalValue);

    if (inputSelctedDismetalValue.length > 0) {
      const obj = {
        search: inputSelctedDismetalValue,
        limit: tableLengthList[0],
        page: 1,
      };

      getDismentalList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setDismetalList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(() => {
    if (partCheckDetails) {
      setPartsCheckData({
        part_catalog_id: partCheckDetails.part_catalog_id || "",
        parts_reference: (partCheckDetails.parts_check_reference || []).map(
          (item) => ({
            ...item,
            type_id: Number(item.type_id),
            condition_id: Number(item.condition_id),
          }),
        ),
        parts_damage: (partCheckDetails.parts_damage || []).map((item) => ({
          ...item,
          location_damage_id: Number(item.location_damage_id),
          type_damage_id: Number(item.type_damage_id),
        })),
        parts_reference_label: partCheckDetails.parts_check_reference || [],
      });

      const loadedImages = partCheckDetails?.image_list?.map((item) => ({
        file: null,
        preview: item.image_url,
        image_url: item.image_url,
        id: item.id,
      }));
      setImage(loadedImages);
      SetPreviewUrl(loadedImages.map((img) => img.preview));
      const loadedVideos = (partCheckDetails?.video_list || []).map((item) => ({
        id: item.id,
        file: null,
        url: item.video_url,
      }));

      setVideos(loadedVideos);
    }
  }, [partCheckDetails]);

  useEffect(() => {
    if (partId) {
      let data = {
        vehicle_id: vehicleProcessList?.vehicle_id
          ? vehicleProcessList?.vehicle_id
          : vehicleId,
        part_catalog_id: partId,
      };
      getPartCheckDetails(data)
        .then((response) => {
          setPartCheckDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [vehicleProcessList, vehicleId, partId]);

  useEffect(() => {
    if (partDetailsId) {
      let data = {
        vehicle_id: vehicleProcessList?.vehicle_id
          ? vehicleProcessList?.vehicle_id
          : vehicleId,
        part_catalog_id: partDetailsId,
      };
      getPartCheckDetails(data)
        .then((response) => {
          setPartAddDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [vehicleProcessList, vehicleId, partDetailsId]);

  useEffect(() => {
    profileDetailForWeb()
      .then((response) => {
        setProfileDetails(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (
      dismentalData?.dismantle_id ||
      dismentalData?.part_check_status ||
      dismentalData?.is_part_converted
    ) {
      setParams((prev) => ({
        ...prev,
        page: 1,
      }));
    }
  }, [dismentalData]);

  useEffect(
    function () {
      let obj = {
        ...params,
        dismental_id: dismentalData?.dismantle_id
          ? dismentalData?.dismantle_id
          : "",
        part_check_status: dismentalData?.part_check_status
          ? dismentalData?.part_check_status
          : "",
        is_part_converted: dismentalData?.is_part_converted
          ? dismentalData?.is_part_converted
          : "",
      };

      getPartCatalogSerachCheck(obj)
        .then((response) => {
          setVehiclePartsManagementList(response.data.data);
          setTotalRecords(response.data.total);
        })
        .catch((err) => {});
    },
    [params, dismentalData],
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "parts_check_status",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartCheckStatusList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "condition",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setConditionList(list);
      })
      .catch((err) => {});
  }, []);
  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "reference",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setReferenceList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "type_damage",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTypeDamageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "location_damage",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setLocationDamageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (partETAIRerList) {
      const data = {
        etai_part_id: partETAIRerList,
      };

      partInvenoryPartETAI(data)
        .then((response) => {
          setPartETAIRefDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [partETAIRerList]);

  useEffect(() => {
    if (!partsCheckData?.parts_reference?.length) return;

    const refCodeConditionData = partsCheckData?.parts_reference?.map(
      (item) => ({
        ref_code: item?.reference_code,
        condition: item?.condition_id,
      }),
    );

    const requestData = {
      search: "",
      limit: 10,
      page: 1,
      refcode_condition: refCodeConditionData,
    };

    getPartRefcodeConditionDetails(requestData)
      .then((response) => setRefCodeConditionDataList(response.data.data))
      .catch((err) => toast.error(Utils.getErrorMessage(err)));
  }, [partsCheckData]);

  useEffect(
    function () {
      if (productVehicleId?.productID) {
        const obj = {
          productID: productVehicleId?.productID,
          language: LangData ? LangData : "PT",
          country: profileDetails?.company_details?.state,
          regNumberCompany:
            profileDetails?.company_details?.company_registration_number,
        };
        getvehicleProductDetails(obj)
          .then((response) => {
            setVehicleCompatibleProductDetails(response.data.data);
          })
          .catch((err) => {});
      }
    },
    [productVehicleId],
  );

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  const handleChangePartStatus = (
    selectedOption,
    partCatalogId,
    partEtaiId,
  ) => {
    const updatedStatus = selectedOption.value;

    setVehiclePartCheckData((prevState) => ({
      ...prevState,
      [partCatalogId]: {
        ...(prevState[partCatalogId] || {}),
        status: updatedStatus,
      },
    }));

    if (selectedOption?.value) {
      let data = {
        vehicle_id: vehicleProcessList?.vehicle_id
          ? vehicleProcessList?.vehicle_id
          : vehicleId,
        part_catalog_id: partCatalogId,
        status: selectedOption?.value,
      };

      getChangePartCheckStatus(data)
        .then((response) => {
          toast.success(response.data.message);
          if (selectedOption?.value === 1) {
            setPartCheckModal(true);
            setPartId(partCatalogId);
            setEtaiPartId(partEtaiId);
          }

          let obj = {
            ...params,
            dismental_id: dismentalData?.dismantle_id
              ? dismentalData?.dismantle_id
              : "",
            part_check_status: dismentalData?.part_check_status
              ? dismentalData?.part_check_status
              : "",
            is_part_converted: dismentalData?.is_part_converted
              ? dismentalData?.is_part_converted
              : "",
          };

          getPartCatalogSerachCheck(obj)
            .then((response) => {
              setVehiclePartsManagementList(response.data.data);
              setTotalRecords(response.data.total);
            })
            .catch((err) => {});
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const handleAddPartRef = async () => {
    if (!selectedReferenceCode || !selectedCondition || !selectedType) {
      toast.error("Please fill all fields.");
      return;
    }

    const isDuplicate = partsCheckData.parts_reference.some(
      (ref) =>
        ref.reference_code.trim().toLowerCase() ===
        selectedReferenceCode.trim().toLowerCase(),
    );

    if (isDuplicate) {
      toast.error("Duplicate reference code is not allowed.");
      return;
    }

    const isFirst = partsCheckData?.parts_reference?.length === 0;

    let count;

    try {
      const response = await getPartsByReference({
        reference_code: selectedReferenceCode,
        data_type: "count",
      });

      count = response?.data.data || 0;
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Failed to validate reference code.");
      return;
    }
    const newRef = {
      id: "",
      reference_code: selectedReferenceCode,
      condition_id: selectedCondition?.value,
      type_id: selectedType?.value,
      is_main: isFirst ? 1 : 0,
      brand: selectedBrandCode,
      manufacter: selectedManufacterCode,
      count: count,
    };
    const newRefLabel = {
      reference_code: selectedReferenceCode,
      condition_name: selectedCondition?.label,
      type_name: selectedType?.label,
      brand: selectedBrandCode,
      manufacter: selectedManufacterCode,
      count: count,
    };

    setPartsCheckData((prev) => ({
      ...prev,
      parts_reference: [...prev.parts_reference, newRef],
      parts_reference_label: [...prev.parts_reference_label, newRefLabel],
    }));

    setSelectedReferenceCode("");
    setSelectedCondition(
      conditionList.find((item) => item.value === 1) || {
        value: 1,
        label: "OEM",
      },
    );

    setSelectedType(
      referenceList.find((item) => item.value === 2) || {
        value: 2,
        label: "Written on the label",
      },
    );
  };

  const handleUpdatePartRef = (index, field, value) => {
    const updated = [...partsCheckData.parts_reference];

    if (field === "is_main" && value === 1) {
      updated.forEach((item, idx) => {
        updated[idx].is_main = idx === index ? 1 : 0;
      });
    } else {
      updated[index][field] = value;
    }

    setPartsCheckData((prev) => ({
      ...prev,
      parts_reference: updated,
    }));
  };

  const handleDeletePartRef = (index) => {
    const updated = [...partsCheckData.parts_reference];
    updated.splice(index, 1);

    setPartsCheckData((prev) => ({
      ...prev,
      parts_reference: updated,
    }));
  };

  const handleSubmitPartRef = (e) => {
    let data = {
      vehicle_id: vehicleProcessList?.vehicle_id
        ? vehicleProcessList?.vehicle_id
        : vehicleId,
      part_catalog_id: partId,
      parts_reference: partsCheckData.parts_reference.map((item) => ({
        id: item.id || "",
        is_main: item.is_main,
        condition_id: item.condition_id,
        type_id: item.type_id,
        reference_code: item.reference_code,
        brand: item.brand,
        manufacter: item.manufacter,
      })),
    };

    createPartsCheckReferenceCheck(data)
      .then((response) => {
        toast.success(response.data.message);
        setActivePartTab("damages");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleAddPartDamage = () => {
    if (
      !selectedDamageDescription ||
      !selectedTypeDamage.value ||
      !selectedLocation.value
    ) {
      toast.error("Please fill all damage fields");
      return;
    }

    const newDamage = {
      damage_description: selectedDamageDescription,
      type_damage_id: selectedTypeDamage.value,
      location_damage_id: selectedLocation.value,
      damage_rating: selectedDamageRating,
    };

    setPartsCheckData((prev) => ({
      ...prev,
      parts_damage: [...prev.parts_damage, newDamage],
    }));

    setSelectedDamageDescription("");
    setSelectedTypeDamage({ value: null, label: "" });
    setSelectedLocation({ value: null, label: "" });
    setSelectedDamageRating(0);
  };

  const handleUpdatePartDamage = (index, field, value) => {
    const updated = [...partsCheckData.parts_damage];

    updated[index][field] = value;

    setPartsCheckData((prev) => ({
      ...prev,
      parts_damage: updated,
    }));
  };

  const handleDeletePartDamage = (index) => {
    const updated = [...partsCheckData.parts_damage];
    updated.splice(index, 1);

    setPartsCheckData((prev) => ({
      ...prev,
      parts_damage: updated,
    }));
  };

  const handleSubmitPartDamage = (e) => {
    setIsloadingDamage(true);

    const data = {
      vehicle_id: vehicleProcessList?.vehicle_id
        ? vehicleProcessList?.vehicle_id
        : vehicleId,
      part_catalog_id: partId,
      parts_damage: partsCheckData.parts_damage.map((item) => ({
        id: item.id || "",
        location_damage_id: item.location_damage_id,
        type_damage_id: item.type_damage_id,
        damage_description: item.damage_description,
        damage_rating: item.damage_rating,
      })),
    };

    createPartsCheckDamage(data)
      .then((response) => {
        toast.success(response.data.message);
        setActivePartTab("photos");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsloadingDamage(false);
      });
  };

  const handleSubmitOCRRef = async () => {
    let error = false;
    let errorObjImport = { ...errorsObjImport };

    if (!file) {
      errorObjImport.file = `File is required.`;
      error = true;
    }

    setErrorsImport(errorObjImport);
    if (error) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await createOCRreferenceRead(formData);
      const data = response.data.data;
      setRefReadData(data);
      // toast.success("Data saved successfully!");
      // setModalOcrRef(false);
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleTextChange = (index, value) => {
    setUpdatedTexts((prev) => ({
      ...prev,
      [index]: value,
    }));

    if (selectedRows[index]) {
      const condition = selectedConditions[index];
      const referenceType = selectedReferenceType[index];
      if (condition && referenceType) {
        const updatedItem = {
          text: value,
          condition_id: condition.value,
          condition_label: condition.label,
          ref_type_id: 2,
          ref_type_label: "Written on the label",
        };

        setSelectedData((prevData) => {
          const filtered = prevData.filter((_, i) => i !== index);
          return [...filtered, updatedItem];
        });
      }
    }
  };

  const handleCheckboxChange = (index) => {
    setSelectedRows((prev) => {
      const newSelectedRows = { ...prev, [index]: !prev[index] };

      const condition = selectedConditions[index];
      const referenceType = selectedReferenceType[index];
      const item = refReadData[index];
      const editedText =
        updatedTexts[index] !== undefined ? updatedTexts[index] : item.text;

      if (!condition) {
        toast.error("Please select the condition");
        return prev;
      }

      if (newSelectedRows[index] && condition) {
        const isDuplicate = selectedData.some(
          (d) =>
            d.text.trim().toLowerCase() === editedText.trim().toLowerCase(),
        );

        if (isDuplicate) {
          toast.error(`${editedText} reference code — already added!`);
          return prev;
        }

        const newEntry = {
          text: editedText,
          condition_id: condition?.value,
          condition_label: condition?.label,
          ref_type_id: 2,
          ref_type_label: "Written on the label",
        };

        setSelectedData((prevData) => {
          const filtered = prevData.filter((d) => d.text !== editedText);
          return [...filtered, newEntry];
        });

        setPartsCheckData((prev) => ({
          ...prev,
          parts_reference: [
            ...prev.parts_reference,
            {
              reference_code: editedText,
              condition_id: condition?.value,
              type_id: 2,
              is_main: 0,
            },
          ],
        }));
      } else {
        setSelectedData((prevData) =>
          prevData.filter(
            (d) =>
              d.text !==
              (updatedTexts[index] !== undefined
                ? updatedTexts[index]
                : item.text),
          ),
        );

        setPartsCheckData((prev) => ({
          ...prev,
          parts_reference: prev.parts_reference.filter(
            (d) =>
              d.reference_code.trim().toLowerCase() !==
              editedText.trim().toLowerCase(),
          ),
        }));
      }

      return newSelectedRows;
    });
  };

  const handleConditionChangeOcr = (index, selectedOption) => {
    setSelectedConditions((prev) => ({
      ...prev,
      [index]: selectedOption,
    }));

    if (selectedRows[index]) {
      const item = refReadData[index];
      setSelectedData((prevData) => [
        ...prevData.filter((d) => d.text !== item.text),
        {
          text: item.text,
          condition_id: selectedOption.value,
          condition_label: selectedOption.label,
        },
      ]);
    }
  };

  const handleReferenceChangeOcr = (index, selectedOption) => {
    setSelectedReferenceType((prev) => ({
      ...prev,
      [index]: selectedOption,
    }));

    if (selectedRows[index]) {
      const item = refReadData[index];
      setSelectedData((prevData) => [
        ...prevData.filter((d) => d.text !== item.text),
        {
          text: item.text,

          ref_type_id: selectedOption.value,
          ref_type_label: selectedOption.label,
        },
      ]);
    }
  };

  const handleOemRefSubmit = (e, item) => {
    if (item) {
      setModifyOemModal(true);
      setLoadingStructureOem(true); // start loading

      let data = {
        refOEM: item.reference_code,
        showAllVehiclesCompatibles: 1,
        language: LangData ? LangData : "PT",
        country: profileDetails?.company_details?.state,
        regNumberCompany:
          profileDetails?.company_details?.company_registration_number,
      };

      getStructureOem(data)
        .then((response) => {
          setStructureOemList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoadingStructureOem(false); // stop loading
        });
    }
  };

  const handleOpenProductConfirm = () => {
    if (selectedVehicleData?.iem_list?.length === 0) {
      toast.error(t("please_select_at_least_one_product"));
      return;
    }
    setModifyConfirmModal(true);
  };

  const handleChangeOemRefClose = () => {
    setModifyOemModal(false);
    setSelectedVehicleData({
      iem_list: [],
      oem_list: [],
      vehicle_compatible_list: [],
    });
    setSelectedOEMIndices([]);
  };

  const handleCheck = (productID) => {
    const isSelected = selectedVehicleData?.iem_list?.some(
      (item) => item.productID === productID,
    );
    const selectedItem = structureOemList?.decode?.equivalentsIAM.find(
      (item) => item.productID === productID,
    );
    setSelectedVehicleData((prev) => {
      const currentList = prev?.iem_list || [];
      return {
        ...prev,
        iem_list: isSelected
          ? currentList.filter((item) => item.productID !== productID)
          : [...currentList, selectedItem],
      };
    });
  };

  const handleCheckAll = () => {
    const list = structureOemList?.decode?.equivalentsIAM || [];

    setSelectedVehicleData((prev) => ({
      ...prev,
      iem_list: prev.iem_list?.length === list?.length ? [] : [...list],
    }));
  };

  const handleCheckOEM = (index) => {
    const list = structureOemList?.decode?.equivalentsOEM || [];
    const selectedItem = list[index];

    if (!selectedItem) return;

    const isSelected = selectedOEMIndices.includes(index);

    const updatedIndices = isSelected
      ? selectedOEMIndices.filter((i) => i !== index)
      : [...selectedOEMIndices, index];

    setSelectedOEMIndices(updatedIndices);

    setSelectedVehicleData((prev) => {
      const updatedList = isSelected
        ? prev.oem_list.filter((_, idx) => idx !== index)
        : [...prev.oem_list, selectedItem];

      return {
        ...prev,
        oem_list: updatedList,
      };
    });
  };

  const handleCheckAllOEM = () => {
    const list = structureOemList?.decode?.equivalentsOEM || [];

    const allIndices = list.map((_, i) => i);
    const isAllSelected = selectedOEMIndices.length === list.length;

    setSelectedOEMIndices(isAllSelected ? [] : allIndices);

    setSelectedVehicleData((prev) => ({
      ...prev,
      oem_list: isAllSelected ? [] : [...list],
    }));
  };

  const handleSelectRef = () => {
    const iemMapped =
      selectedVehicleData?.iem_list?.map((item) => ({
        reference_code: item.reference,
        condition_id: 2,
        type_id: 1,
        is_main: 0,
        productID: item.productID,
        brand: item?.brandName,
        manufacter: item?.manufacter,
      })) || [];

    const oemMapped =
      selectedVehicleData?.oem_list?.map((item) => ({
        reference_code: item.reference,
        condition_id: 1,
        type_id: 1,
        is_main: 0,
        productID: item.productID,
        brand: item?.brandName,
        manufacter: item?.manufacter,
      })) || [];

    const mergedRefs = [...iemMapped, ...oemMapped];

    setPartsCheckData((prev) => {
      const existing = prev.parts_reference || [];

      const newRefs = mergedRefs.filter(
        (newItem) =>
          !existing.some(
            (existingItem) =>
              existingItem.reference_code === newItem.reference_code,
          ),
      );

      return {
        ...prev,
        parts_reference: [...existing, ...newRefs],
      };
    });

    const vehicleMapped =
      selectedVehicleData?.vehicle_compatible_list?.map((item) => ({
        ...item,
      })) || [];

    const newUniqueVehicles = vehicleMapped?.filter(
      (item) =>
        !vehicleSelectedComDataList?.some(
          (existing) => existing.variantID === item.variantID,
        ),
    );

    setVehicleSelectedComDataList((prev) => [...prev, ...newUniqueVehicles]);

    setModifyOemModal(false);

    setSelectedVehicleData({
      iem_list: [],
      oem_list: [],
      vehicle_compatible_list: [],
    });

    setSelectedOEMIndices([]);
  };

  const handleAboutFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);

    if (selectedFiles.length > 0) {
      const formattedFiles = selectedFiles.map((file, index) => ({
        id: `${Date.now()}-${index}`,
        file,
        url: URL.createObjectURL(file),
      }));

      setImage((prevImages) => [...prevImages, ...formattedFiles]);

      const newPreviewUrls = formattedFiles.map((file) => file.url);
      SetPreviewUrl((prevUrls) => [...prevUrls, ...newPreviewUrls]);
    }
  };

  const handleImageSelect = (file) => {
    setImage((prevFiles) =>
      prevFiles.map((f) => (f.id === file.id ? { ...f } : f)),
    );
    setSelectedImage(file);
    setCrop(null);
    setRotation(0);
    setHighlights([]);
    setIsModalOpen(true);
  };

  const toggleEnlarge = (index) => {
    if (enlargedIndexes.includes(index)) {
      setEnlargedIndexes(enlargedIndexes.filter((i) => i !== index));
    } else {
      setEnlargedIndexes([...enlargedIndexes, index]);
    }
  };

  const onImageLoad = (img) => {
    imgRef.current = img;
  };

  const onImageClick = (e) => {
    const { offsetX, offsetY } = e.nativeEvent;
    const newHighlight = {
      x: offsetX,
      y: offsetY,
      radius: 20,
      color: selectedColor,
    };

    setHighlights([...highlights, newHighlight]);
  };

  const handleCrop = () => {
    setIsCropping(!isCropping);
  };

  const saveDrawing = async (fileId) => {
    setIsDrawing((prev) => !prev);
  };

  const getCroppedImage = async () => {
    if (!imgRef.current || !selectedImage) return;

    const image = imgRef.current;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    let cropX = 0,
      cropY = 0,
      cropWidth = image.naturalWidth,
      cropHeight = image.naturalHeight;

    if (completedCrop) {
      cropX = completedCrop.x * scaleX;
      cropY = completedCrop.y * scaleY;
      cropWidth = completedCrop.width * scaleX;
      cropHeight = completedCrop.height * scaleY;
    }

    const radians = (rotation * Math.PI) / 180;
    canvas.width = cropWidth;
    canvas.height = cropHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();

    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(radians);
    ctx.translate(-canvas.width / 2, -canvas.height / 2);

    ctx.drawImage(
      image,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      cropWidth,
      cropHeight,
    );

    ctx.restore();

    if (canvasRef.current) {
      try {
        const drawingDataURL = await canvasRef.current.exportImage("png");

        if (drawingDataURL) {
          const drawingImage = new Image();
          drawingImage.src = drawingDataURL;
          await new Promise((resolve) => (drawingImage.onload = resolve));

          ctx.drawImage(drawingImage, 0, 0, cropWidth, cropHeight);
        }
      } catch (error) {
        console.error("Error exporting drawing:", error);
      }
    }

    const editedImage = canvas.toDataURL("image/jpeg");

    setImage((prevFiles) =>
      prevFiles.map((file) =>
        file.id === selectedImage.id ? { ...file, url: editedImage } : file,
      ),
    );
    // Cleanup
    setSelectedImage(null);
    setIsModalOpen(false);
    setCompletedCrop(null);
    setHighlights([]);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // const handleRemoveFile = (indexToRemove, id) => {
  //   setImage((prevFiles) =>
  //     prevFiles.filter((_, index) => index !== indexToRemove)
  //   );
  //   SetPreviewUrl((prevUrls) =>
  //     prevUrls.filter((_, index) => index !== indexToRemove)
  //   );

  //   if (images.length === 1) {
  //     fileInputRef.current.value = "";
  //   }
  // };

  const handleRemoveFile = async (indexToRemove, id) => {
    try {
      // Call API to delete image on backend
      if (id) {
        const data = { id: id };

        deletePartsCheckImage(data)
          .then((response) => {
            toast.success(response.data.message);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });
      }

      // Update local state after successful API call
      setImage((prevFiles) =>
        prevFiles.filter((_, index) => index !== indexToRemove),
      );
      SetPreviewUrl((prevUrls) =>
        prevUrls.filter((_, index) => index !== indexToRemove),
      );

      // Clear file input if no more images left
      if (images.length === 1) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Failed to delete image:", error);
      // Optionally show user feedback here
    }
  };

  const handleRemoveBgImageeForm = async (fileId) => {
    const selectedImage = images.find((file) => file.id === fileId);

    if (!selectedImage) {
      toast.error("Please select an image first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedImage.file);

    setIsLoading(true);

    try {
      const response = await fetch(
        "https://images.tp.software/remove-bg/",
        {
          method: "POST",
          body: formData,
        },
      );

      let imageBlob;

      if (!response.ok) throw new Error("Failed to remove background");
      imageBlob = await response.blob();

      const imageUrl = URL.createObjectURL(imageBlob);
      setImage((prevFiles) =>
        prevFiles.map((file) =>
          file.id === fileId
            ? { ...file, url: imageUrl, file: imageBlob }
            : file,
        ),
      );

      toast.success("Background removed successfully!");
      setSelectedImage({ url: imageUrl });
      setIsModalOpen(false);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddBgImageForm = async (fileId) => {
    const selectedImage = images.find((file) => file.id === fileId);
    const proxyUrl = "https://api.allorigins.win/raw?url=";

    const response = await fetch(
      proxyUrl + encodeURIComponent(settingCompanyDetails?.default_image),
    );
    if (!response.ok) throw new Error("Default image is not available");

    const blob = await response.blob();
    const file = new File([blob], "background.jpg", { type: blob.type });

    if (!selectedImage) {
      toast.error("Please select an image first.");
      return;
    }

    const formData = new FormData();
    formData.append("main_image", selectedImage?.file);
    formData.append("bg_image", file);

    setIsLoadings(true);

    try {
      const response = await fetch("https://images.tp.software/add-bg/", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to remove background");

      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);
      setImage((prevFiles) =>
        prevFiles.map((file) =>
          file.id === fileId
            ? { ...file, url: imageUrl, file: imageBlob }
            : file,
        ),
      );

      toast.success("Background add successfully!");
      setSelectedImage({ url: imageUrl });
      setIsModalOpen(false);
    } catch (error) {
    } finally {
      setIsLoadings(false);
    }
  };

  const handleAddBgColoreForm = async (fileId) => {
    const selectedImage = images.find((file) => file.id === fileId);

    if (!selectedImage) {
      toast.error("Please select an image first.");
      return;
    }

    const encodedColor = encodeURIComponent(
      settingCompanyDetails?.default_color,
    );

    const formData = new FormData();
    formData.append("main_image", selectedImage.file);

    setIsLoadingColor(true);

    try {
      const response = await fetch(
        `https://images.tp.software/add-bg-color/?hex_color=${encodedColor}`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) throw new Error("Failed to add background color");

      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);
      setImage((prevFiles) =>
        prevFiles.map((file) =>
          file.id === fileId
            ? { ...file, url: imageUrl, file: imageBlob }
            : file,
        ),
      );

      toast.success("Background color added successfully!");
      setSelectedImage({ url: imageUrl });
      setIsModalOpen(false);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsLoadingColor(false);
    }
  };

  const hasProcessedRef = useRef(false);

  useEffect(() => {
    if (hasProcessedRef.current) return;

    if (!images?.length || !settingCompanyDetails?.edit_photo_type) return;

    hasProcessedRef.current = true;

    const type = settingCompanyDetails.edit_photo_type;

    images.forEach((file) => {
      if (type === 2) {
        handleRemoveBgImageeForm(file.id);
      } else if (type === 3) {
        handleAddBgColoreForm(file.id);
      } else if (type === 4) {
        handleAddBgImageForm(file.id);
      }
    });
  }, [images, settingCompanyDetails]);

  const handleRotate = async (fileId) => {
    setRotation((prev) => (prev + 90) % 360);
  };

  const handleSubmitImage = (event) => {
    event.preventDefault();
    setIsloadingImage(true);

    const newFiles = images.filter((item) => item.file instanceof File);

    if (newFiles.length === 0) {
      setActivePartTab("videos");
      setIsloadingImage(false);
      return;
    }

    const formData = new FormData();
    formData.append(
      "vehicle_id",
      vehicleProcessList?.vehicle_id
        ? vehicleProcessList?.vehicle_id
        : vehicleId,
    );
    formData.append("part_catalog_id", partId);

    images.forEach((item) => {
      if (item.file instanceof File) {
        formData.append("files", item.file);
      } else {
        console.error("Invalid file object:", item.file);
      }
    });

    createPartsCheckImage(formData)
      .then((response) => {
        toast.success(response.data.message);
        setImage([]);

        const data = {
          vehicle_id: vehicleProcessList?.vehicle_id
            ? vehicleProcessList?.vehicle_id
            : vehicleId,
          part_catalog_id: partId,
        };

        getPartCheckDetails(data)
          .then((response) => {
            setPartCheckDetails(response.data.data);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });

        if (images.length === 1) {
          fileInputRef.current.value = "";
        }

        setActivePartTab("videos");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsloadingImage(false);
      });
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files).map((file, index) => ({
      file,
      id: 0,
      sequence: videos.length + index + 1,
    }));

    setVideos((prev) => [...prev, ...newFiles]);
  };

  const handleRemoveVideo = (index, id) => {
    if (id) {
      setIsModalVideoDelete(true);
      setvideoDataId(id);
    } else {
      setVideos((prev) => {
        const updated = [...prev];
        updated.splice(index, 1);
        return updated;
      });

      if ((videos?.length || 0) === 1 && fileInputRefs.current) {
        fileInputRefs.current.value = "";
      }
    }
  };

  const handleEditRemoveVideo = async () => {
    const data = { id: videoDataId };

    deletePartsCheckVideo(data)
      .then((response) => {
        toast.success(response.data.message);

        setVideos((prevVideos) =>
          prevVideos.filter((video) => video.id !== videoDataId),
        );

        setIsModalVideoDelete(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleDeleteClose = () => {
    setIsModalVideoDelete(false);
  };

  const handleSubmitVideo = (event) => {
    event.preventDefault();
    setIsloadingVideo(true);

    const allVideos = Object.values(videos).flat();
    const newFiles = allVideos.filter((video) => video.file);

    const part_video_size =
      settingCompanyDetails?.part_video_size * 1024 * 1024;

    if (newFiles.length > settingCompanyDetails?.part_video_limit) {
      toast.error(
        `You can only upload up to ${settingCompanyDetails?.part_video_limit} videos.`,
      );
      setIsloadingVideo(false);
      return;
    }

    const oversizedFiles = newFiles.filter(
      (video) => video.file.size > part_video_size,
    );
    if (oversizedFiles.length > 0) {
      toast.error(
        `Each video must be under ${settingCompanyDetails?.part_video_size}MB.`,
      );
      setIsloadingVideo(false);
      return;
    }

    if (newFiles.length === 0) {
      setIsloadingVideo(false);
      return;
    }

    const formData = new FormData();
    formData.append(
      "vehicle_id",
      vehicleProcessList?.vehicle_id
        ? vehicleProcessList?.vehicle_id
        : vehicleId,
    );
    formData.append("part_catalog_id", partId);

    newFiles.forEach((video) => formData.append("files[]", video.file));

    createPartsCheckVideo(formData)
      .then((response) => {
        toast.success(response.data.message);
        setImage([]);
        const data = {
          vehicle_id: vehicleProcessList?.vehicle_id
            ? vehicleProcessList?.vehicle_id
            : vehicleId,
          part_catalog_id: partId,
        };
        getPartCheckDetails(data)
          .then((response) => {
            setPartCheckDetails(response.data.data);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });
        if (images.length === 1) {
          fileInputRef.current.value = "";
        }
        setActivePartTab("videos");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setIsloadingVideo(false);
      });
  };

  const handleConvertPart = async () => {
    const data = {
      vehicle_id: vehicleProcessList?.vehicle_id
        ? vehicleProcessList?.vehicle_id
        : vehicleId,
      part_catalog_id: convertPartId,
    };

    createConvertPart(data)
      .then((response) => {
        toast.success(response.data.message);
        setModifyConvert(false);

        let obj = {
          ...params,
          dismental_id: dismentalData?.dismantle_id ?? "",
          part_check_status: dismentalData?.part_check_status ?? "",
          is_part_converted: dismentalData?.is_part_converted ?? "",
        };

        getPartCatalogSerachCheck(obj)
          .then((response) => {
            setVehiclePartsManagementList(response.data.data);
            setTotalRecords(response.data.total);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleOpenPartRefHistory = async (e, item) => {
    try {
      const response = await getPartsByReference({
        search: "",
        limit: 10,
        page: 1,
        reference_code: item,
        data_type: "list",
      });

      setCatalogModalStateRefDataList(response.data.data);
      setModalStateRefHistory(true);
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
      return;
    }
  };

  const handleClosePartRefHistory = () => {
    setModalStateRefHistory(false);
  };

  const handleDismentalSubmit = () => {
    setLoadingDismental(true);
    let obj = {
      dismantle_id: dismentalData?.dismantle_id ?? "",
      vehicle_id: vehicleProcessList?.vehicle_id
        ? vehicleProcessList?.vehicle_id
        : vehicleId,
    };

    getDismentalAllPartsCheckStatus(obj)
      .then((response) => {
        let obj = {
          ...params,
          dismental_id: dismentalData?.dismantle_id
            ? dismentalData?.dismantle_id
            : "",
          part_check_status: dismentalData?.part_check_status
            ? dismentalData?.part_check_status
            : "",
          is_part_converted: dismentalData?.is_part_converted
            ? dismentalData?.is_part_converted
            : "",
        };

        getPartCatalogSerachCheck(obj)
          .then((response) => {
            setVehiclePartsManagementList(response.data.data);
            setTotalRecords(response.data.total);
            setLoadingDismental(false);
          })
          .catch((err) => {
            setLoadingDismental(false);
          });
      })

      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <div className="card card-primary">
            <Form method="post">
              <div className="card-body">
                <div className="row justify-content-start mb-5 ms-1 me-1">
                  <React.Fragment>
                    <div className="fileupload-content">
                      <div className="row justify-content-start mt-4 mb-4">
                        <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            value={params.search}
                            onChange={(e) => handleParams(e, "search")}
                            placeholder={t("search_by_internal_id")}
                          ></input>
                        </div>
                        <div className="col-md-3">
                          <div
                            className="card-title m-0 float-left"
                            style={{ width: "100%" }}
                          >
                            <Select
                              className="my-Select"
                              options={DismetalList}
                              value={
                                DismetalList.find(
                                  (item) =>
                                    item.value === dismentalData.dismantle_id,
                                ) || null
                              }
                              onChange={(option) =>
                                setDismentalData((prevData) => ({
                                  ...prevData,
                                  dismantle_id: option?.value || null, // safely handle null
                                }))
                              }
                              placeholder={t("select_dismental")}
                              isSearchable={true}
                              isClearable
                              onInputChange={
                                handleInputSelectedChangeDismetalList
                              }
                              inputValue={inputSelctedDismetalValue}
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div
                            className="card-title m-0 float-left"
                            style={{ width: "100%" }}
                          >
                            <Select
                              options={ConfigDB?.data?.partCheckList}
                              value={
                                ConfigDB?.data?.partCheckList.find(
                                  (option) =>
                                    option.value ===
                                    dismentalData.part_check_status,
                                ) || 0
                              }
                              onChange={(selectedOption) =>
                                setDismentalData({
                                  ...dismentalData,
                                  part_check_status: selectedOption
                                    ? selectedOption.value
                                    : "",
                                })
                              }
                              placeholder={"Select Part Check Status"}
                              isSearchable
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div
                            className="card-title m-0 float-left"
                            style={{ width: "100%" }}
                          >
                            <Select
                              options={ConfigDB?.data?.partCheckConvertedList}
                              value={
                                ConfigDB?.data?.partCheckConvertedList.find(
                                  (option) =>
                                    option.value ===
                                    dismentalData.is_part_converted,
                                ) || 0
                              }
                              onChange={(selectedOption) =>
                                setDismentalData({
                                  ...dismentalData,
                                  is_part_converted: selectedOption
                                    ? selectedOption.value
                                    : "",
                                })
                              }
                              placeholder={"Select Part Converted"}
                              isSearchable
                            />
                          </div>
                        </div>

                        <div className="col-md-12 mt-3 d-flex justify-content-end">
                          {dismentalData?.dismantle_id && (
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={loadingDismental}
                              onClick={handleDismentalSubmit}
                            >
                              {loadingDismental
                                ? "Searching..."
                                : "Verify all parts from list"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="vehicleThBg table-responsive min-height-0 pb-2">
                          <table className="rounded-table table table-striped table-bordered table-hover">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>{t("catalog")}</th>

                                <th style={{ width: "10%" }}>
                                  {t("part_checked")}
                                </th>
                                <th style={{ width: "10%" }}></th>
                              </tr>
                            </thead>

                            <tbody>
                              {vehiclePartsManagementList?.length > 0 ? (
                                vehiclePartsManagementList?.map(
                                  (item, index) => {
                                    const rowKey = `${params.page}_${item.id}`;

                                    const selectedStatus =
                                      vehiclePartCheckData[rowKey]?.status ??
                                      item?.part_check_status ??
                                      0;

                                    const selectedOption =
                                      partCheckStatusList.find(
                                        (option) =>
                                          option.value ===
                                          Number(selectedStatus),
                                      );

                                    return (
                                      <tr key={rowKey}>
                                        <td>{item?.namePartPT}</td>
                                        <td>
                                          <Select
                                            className="my-select-v"
                                            options={partCheckStatusList}
                                            value={selectedOption}
                                            onChange={(selectedOption) =>
                                              handleChangePartStatus(
                                                selectedOption,
                                                item?.id,
                                                item?.etai_part_id,
                                              )
                                            }
                                            placeholder={t("select_vehicle_part_check")}
                                            isDisabled={
                                              item?.part_converted_status === 1
                                            }
                                            menuPortalTarget={document.body}
                                            styles={{
                                              menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                              }),
                                            }}
                                          />
                                        </td>
                                        {item?.part_converted_status === 1 ? (
                                          <td style={{ display: "flex" }}>
                                            <div
                                              className="edit-btn"
                                              onClick={(e) =>
                                                handlePartDetailsOpen(e, item)
                                              }
                                              style={{
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <i className="bi bi-info-circle"></i>
                                            </div>

                                            {item?.part_id !== 0 ? (
                                              <div
                                                className="edit-btn"
                                                onClick={() =>
                                                  navigate(
                                                    `/part/details/inven/${item.part_id}`,
                                                  )
                                                }
                                                style={{
                                                  marginLeft: "10px",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <i className="bi bi-tools"></i>
                                              </div>
                                            ) : null}
                                          </td>
                                        ) : item?.part_check_status === 1 ? (
                                          <td style={{ display: "flex" }}>
                                            <div
                                              className="edit-btn"
                                              onClick={() => {
                                                setPartCheckModal(true);
                                                setPartId(item.id);
                                              }}
                                              style={{ cursor: "pointer" }}
                                            >
                                              <i className="bi bi-eye-fill"></i>
                                            </div>

                                            <div
                                              className="edit-btn"
                                              onClick={(e) =>
                                                handleConvertPartOpen(e, item)
                                              }
                                              style={{
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <i className="bi bi-gear"></i>
                                            </div>

                                            <div
                                              className="edit-btn"
                                              onClick={(e) =>
                                                handlePartDetailsOpen(e, item)
                                              }
                                              style={{
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <i className="bi bi-info-circle"></i>
                                            </div>
                                          </td>
                                        ) : null}
                                      </tr>
                                    );
                                  },
                                )
                              ) : (
                                <tr className="scrollBrdr">
                                  <td colSpan={6}>{t("no_record_found")}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="card-footer clearfix card-footer-part fuelCF">
                        <div className="pagination pagination-sm m-0 float-right">
                          <ReactPaginate
                            previousLabel={
                              <i className="bi bi-chevron-double-left"></i>
                            }
                            nextLabel={
                              <i className="bi bi-chevron-double-right"></i>
                            }
                            breakLabel={"..."}
                            pageCount={Math.ceil(totalRecords / params.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(e) => handleParams(e, "pagination")}
                            forcePage={params.page - 1}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                          />
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                </div>
                <div className="back-footer">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <button
                        type="button"
                        className="next-button btn btn-secondary"
                        onClick={() => setActiveTab("vehicle_part_mangement")}
                      >
                        <i className="bi bi-arrow-left"></i> {t("back")}
                      </button>
                    </div>
                    <div className="col-4 text-center">
                      <small style={{ color: "#9ca3af" }}>
                        {t("tool_label")}
                      </small>
                    </div>
                    <div className="col-4 text-end">
                      <button
                        type="button"
                        className="btn btn-primary nxt-btn"
                        onClick={() => setActiveTab("depreciation")}
                      >
                        {t("save_and_continue")}
                        <i className="bi bi-arrow-right ms-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <Modal isOpen={partCheckModal} className="modal-fullscreen">
        <ModalHeader className="modal-custom-header">{t("part_check")}</ModalHeader>
        <ModalBody>
          <Nav tabs className="nav-tap-modal">
            <NavItem>
              <NavLink
                className={`nav-link ${
                  activePartTab === "references" ? "active" : ""
                }`}
                onClick={() => toggleTab("references")}
                style={{ cursor: "pointer" }}
              >
                📌 References
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`nav-link ${
                  activePartTab === "damages" ? "active" : ""
                }`}
                onClick={() => toggleTab("damages")}
                style={{ cursor: "pointer" }}
              >
                ⚠️ Damages
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`nav-link ${
                  activePartTab === "photos" ? "active" : ""
                }`}
                onClick={() => toggleTab("photos")}
                style={{ cursor: "pointer" }}
              >
                📷 Photos
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`nav-link ${
                  activePartTab === "videos" ? "active" : ""
                }`}
                onClick={() => toggleTab("videos")}
                style={{ cursor: "pointer" }}
              >
                🎥 Videos
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activePartTab} className="mt-3">
            <TabPane tabId="references">
              <div>
                <div className="col-lg-12">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="col-md-2">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleChangeOCROpen}
                          style={{
                            width: "200px",
                            marginTop: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          OCR Multiple Reference
                        </button>
                      </div>

                      {partsCheckData?.parts_reference?.length > 0 && (
                        <>
                          <div className="col-md-2">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={(e) => handleOpenRefCodeCondition(e)}
                              style={{
                                width: "100px",
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                            >
                              Parts
                            </button>
                          </div>

                          <div className="col-md-2">
                            <button
                              style={{
                                marginTop: "10px",
                                width: "132px",
                                marginBottom: "10px",
                              }}
                              type="button"
                              className="btn btn-primary"
                              onClick={(e) => handleOpenRefCodeEstimate(e)}
                            >
                              Estimate Price
                            </button>
                          </div>
                        </>
                      )}

                      {etaiPartId && (
                        <div className="col-md-2">
                          <button
                            style={{
                              marginTop: "8px",
                              marginRight: "10px",
                              marginBottom: "10px",
                            }}
                            type="button"
                            className="btn btn-primary"
                            onClick={(e) => handleEtaiDetails(e)}
                          >
                            View Reference
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="table-responsive-custom-q table-custom-sticky-inherit">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="col-lg-12 addPartField">
                                <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                  Reference Code
                                </label>
                              </div>
                            </th>

                            <th scope="col">
                              <div className="col-lg-12 addPartField">
                                <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                  Condition
                                </label>
                              </div>
                            </th>

                            <th scope="col">
                              <div className="col-lg-12 addPartField">
                                <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                  Reference Type
                                </label>
                              </div>
                            </th>

                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th></th>
                            <th scope="col">
                              <button
                                type="button"
                                className="btn btn-block"
                                onClick={handleSubmitPartRef}
                                style={{
                                  width: "100px",
                                  marginTop: "10px",
                                  backgroundColor: "rgb(58 82 31)",
                                  borderColor: "#81bb42",
                                  color: "white",
                                }}
                              >
                                {t("submit")} <i className="bi bi-check2"></i>
                              </button>
                            </th>
                            <th scope="col"></th>
                          </tr>
                        </thead>

                        <thead>
                          <tr>
                            <td scope="col">
                              <input
                                className="form-control input-search"
                                type="text"
                                name="reference_code"
                                value={selectedReferenceCode}
                                onChange={(e) =>
                                  setSelectedReferenceCode(e.target.value)
                                }
                                placeholder={t("reference_code")}
                              />
                            </td>

                            <td scope="col">
                              <Select
                                className="my-Select"
                                options={conditionList}
                                value={selectedCondition}
                                onChange={(selectedOption) =>
                                  setSelectedCondition({
                                    value: selectedOption?.value || null,
                                    label: selectedOption?.label || "",
                                  })
                                }
                                isSearchable
                                placeholder={t("select_condition")}
                              />
                            </td>

                            <td scope="col">
                              <Select
                                className="my-Select"
                                options={referenceList}
                                value={selectedType}
                                onChange={(selectedOption) =>
                                  setSelectedType({
                                    value: selectedOption?.value || null,
                                    label: selectedOption?.label || "",
                                  })
                                }
                                isSearchable
                                placeholder={t("select_type")}
                              />
                            </td>

                            {selectedCondition.value === 2 &&
                              selectedType === 1 && (
                                <td scope="col">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="brand"
                                    value={selectedBrandCode}
                                    onChange={(e) =>
                                      setSelectedBrandCode(e.target.value)
                                    }
                                    placeholder={t("brand")}
                                  />
                                </td>
                              )}

                            {selectedType === 1 && (
                              <td scope="col">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="manufacter"
                                  value={selectedManufacterCode}
                                  onChange={(e) =>
                                    setSelectedManufacterCode(e.target.value)
                                  }
                                  placeholder={t("manufacter")}
                                />
                              </td>
                            )}

                            <td>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAddPartRef}
                              >
                                Add Reference
                              </button>
                            </td>
                            <td></td>
                          </tr>
                        </thead>

                        <tbody>
                          {partsCheckData.parts_reference.map(
                            (data, rowIndex) => (
                              <tr key={rowIndex}>
                                <td>
                                  <div className="col-lg-12 addPartField">
                                    <label className="partsLabel col-form-label ml-2"></label>
                                    <button
                                      style={{
                                        marginLeft: "12px",
                                      }}
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        handleOpenPartRefHistory(
                                          e,
                                          data.reference_code,
                                        );
                                      }}
                                    >
                                      {data?.count ? data?.count : 0}
                                    </button>
                                  </div>
                                </td>
                                <td>
                                  <div className="col-lg-12 addPartField">
                                    <label className="partsLabel col-form-label ml-2">
                                      Reference Code
                                    </label>
                                    <input
                                      className="form-control input-search"
                                      type="text"
                                      value={data.reference_code}
                                      onChange={(e) =>
                                        handleUpdatePartRef(
                                          rowIndex,
                                          "reference_code",
                                          e.target.value,
                                        )
                                      }
                                      placeholder={t("reference_code")}
                                    />
                                  </div>
                                </td>

                                <td>
                                  <label className="partsLabel col-form-label ml-2">
                                    Condition
                                  </label>
                                  <Select
                                    className="my-Select"
                                    options={conditionList}
                                    value={conditionList.find(
                                      (opt) => opt.value === data.condition_id,
                                    )}
                                    onChange={(selectedOption) =>
                                      handleUpdatePartRef(
                                        rowIndex,
                                        "condition_id",
                                        selectedOption?.value || null,
                                      )
                                    }
                                    isSearchable
                                    placeholder={t("select_condition")}
                                  />
                                </td>

                                <td>
                                  <label className="partsLabel col-form-label ml-2">
                                    Reference Type
                                  </label>
                                  <Select
                                    className="my-Select"
                                    options={referenceList}
                                    value={referenceList.find(
                                      (opt) => opt.value === data.type_id,
                                    )}
                                    onChange={(selectedOption) =>
                                      handleUpdatePartRef(
                                        rowIndex,
                                        "type_id",
                                        selectedOption?.value || null,
                                      )
                                    }
                                    isSearchable
                                    placeholder={t("select_type")}
                                  />
                                </td>
                                {data.condition_id === 2 &&
                                  data.type_id === 1 && (
                                    <td>
                                      <div className="col-lg-12 addPartField">
                                        <label className="partsLabel col-form-label ml-2">
                                          Brand
                                        </label>
                                        <input
                                          className="form-control input-search"
                                          type="text"
                                          value={data.brand}
                                          onChange={(e) =>
                                            handleUpdatePartRef(
                                              rowIndex,
                                              "brand",
                                              e.target.value,
                                            )
                                          }
                                          placeholder={t("brand")}
                                        />
                                      </div>
                                    </td>
                                  )}

                                {data.type_id === 1 && (
                                  <td>
                                    <div className="col-lg-12 addPartField">
                                      <label className="partsLabel col-form-label ml-2">
                                        Manufacter
                                      </label>
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={data.manufacter}
                                        onChange={(e) =>
                                          handleUpdatePartRef(
                                            rowIndex,
                                            "manufacter",
                                            e.target.value,
                                          )
                                        }
                                        placeholder={t("manufacter")}
                                      />
                                    </div>
                                  </td>
                                )}

                                <td>
                                  <div className="form-check text-left">
                                    <label className="partsLabel col-form-label ml-2">
                                      Is Main
                                    </label>
                                    <input
                                      style={{ marginLeft: "20px" }}
                                      className="form-check-input"
                                      type="radio"
                                      name="isMainRadioGroup"
                                      checked={data?.is_main === 1}
                                      onChange={() =>
                                        handleUpdatePartRef(
                                          rowIndex,
                                          "is_main",
                                          1,
                                        )
                                      }
                                    />
                                  </div>
                                </td>

                                <td>
                                  <div className="form-check text-left">
                                    <label className="partsLabel col-form-label ml-2"></label>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() =>
                                        handleDeletePartRef(rowIndex)
                                      }
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </td>

                                <td></td>
                                {settingCompanyDetails?.reference_type === 2 &&
                                  settingCompanyDetails?.reference_condition ===
                                    1 &&
                                  data.condition_id === 1 &&
                                  data.type_id === 2 && (
                                    <td>
                                      <div className="form-check text-left">
                                        <label className="partsLabel col-form-label ml-2"></label>
                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                          onClick={(e) =>
                                            handleOemRefSubmit(e, data)
                                          }
                                          style={{
                                            width: "150px",
                                            marginLeft: "-157px",
                                          }}
                                        >
                                          {t("oem_references")}
                                        </button>
                                      </div>
                                    </td>
                                  )}
                              </tr>
                            ),
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="damages">
              <div>
                <div className="col-lg-12">
                  <div className="col-lg-12">
                    <div className="table-responsive-custom-q table-custom-sticky-inherit">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="col-lg-12 addPartField">
                                <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                  Damage Description
                                </label>
                              </div>
                            </th>

                            <th scope="col">
                              <div className="col-lg-12 addPartField">
                                <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                  Type Damage
                                </label>
                              </div>
                            </th>

                            <th scope="col">
                              <div className="col-lg-12 addPartField">
                                <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                  Location Damage
                                </label>
                              </div>
                            </th>
                            <th scope="col">
                              <div className="col-lg-12 addPartField">
                                <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                  Damage Rating
                                </label>
                              </div>
                            </th>

                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col">
                              <button
                                type="button"
                                className="btn btn-block"
                                onClick={handleSubmitPartDamage}
                                disabled={isloadingDamage}
                                style={{
                                  width: "100px",
                                  marginTop: "10px",
                                  backgroundColor: "rgb(58 82 31)",
                                  borderColor: "#81bb42",
                                  color: "white",
                                }}
                              >
                                {isloadingDamage ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-1"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    {t("submitting")}...
                                  </>
                                ) : (
                                  <>
                                    {t("submit")}{" "}
                                    <i className="bi bi-check2"></i>
                                  </>
                                )}
                              </button>
                            </th>
                          </tr>
                        </thead>

                        <thead>
                          <tr>
                            <td scope="col">
                              <input
                                className="form-control input-search"
                                type="text"
                                name="damage_description"
                                value={selectedDamageDescription}
                                onChange={(e) =>
                                  setSelectedDamageDescription(e.target.value)
                                }
                                placeholder={t("damage_description")}
                              />
                            </td>

                            <td scope="col">
                              <Select
                                className="my-Select"
                                options={typeDamageList}
                                value={selectedTypeDamage}
                                onChange={(selectedOption) =>
                                  setSelectedTypeDamage({
                                    value: selectedOption?.value || null,
                                    label: selectedOption?.label || "",
                                  })
                                }
                                isSearchable
                                placeholder={t("select_type_damage")}
                              />
                            </td>

                            <td scope="col">
                              <Select
                                className="my-Select"
                                options={locationDamageList}
                                value={selectedLocation}
                                onChange={(selectedOption) =>
                                  setSelectedLocation({
                                    value: selectedOption?.value || null,
                                    label: selectedOption?.label || "",
                                  })
                                }
                                isSearchable
                                placeholder={t("select_location_damage")}
                              />
                            </td>

                            <td scope="col">
                              <ReactStars
                                size={20}
                                count={5}
                                value={selectedDamageRating} // This is 0
                                onChange={(newRating) =>
                                  setSelectedDamageRating(newRating)
                                }
                                activeColor={
                                  selectedDamageRating > 0 ? "#ffd700" : "gray"
                                } // for value > 0
                                isHalf={true}
                                a11y={true}
                                emptyIcon={
                                  <i
                                    className="bi bi-star"
                                    style={{ color: "gray" }}
                                  />
                                }
                                halfIcon={
                                  <i
                                    className="bi bi-star-half"
                                    style={{ color: "#ffd700" }}
                                  />
                                }
                                filledIcon={
                                  <i
                                    className="bi bi-star-fill"
                                    style={{ color: "#ffd700" }}
                                  />
                                }
                              />
                            </td>

                            <td>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAddPartDamage}
                              >
                                Add Damage
                              </button>
                            </td>
                            <td></td>
                          </tr>
                        </thead>

                        <tbody>
                          {partsCheckData.parts_damage.map((data, rowIndex) => (
                            <tr key={rowIndex}>
                              <td>
                                <div className="col-lg-12 addPartField">
                                  <label className="partsLabel col-form-label ml-2">
                                    Damage description
                                  </label>
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={data.damage_description}
                                    onChange={(e) =>
                                      handleUpdatePartDamage(
                                        rowIndex,
                                        "damage_description",
                                        e.target.value,
                                      )
                                    }
                                    placeholder={t("damage_description")}
                                  />
                                </div>
                              </td>

                              <td>
                                <label className="partsLabel col-form-label ml-2">
                                  Damage type
                                </label>
                                <Select
                                  className="my-Select"
                                  options={typeDamageList}
                                  value={typeDamageList.find(
                                    (opt) => opt.value === data.type_damage_id,
                                  )}
                                  onChange={(selectedOption) =>
                                    handleUpdatePartDamage(
                                      rowIndex,
                                      "type_damage_id",
                                      selectedOption?.value || null,
                                    )
                                  }
                                  isSearchable
                                  placeholder={t("select_damage_type")}
                                />
                              </td>

                              <td>
                                <label className="partsLabel col-form-label ml-2">
                                  Damage Location type
                                </label>
                                <Select
                                  className="my-Select"
                                  options={locationDamageList}
                                  value={locationDamageList.find(
                                    (opt) =>
                                      opt.value === data.location_damage_id,
                                  )}
                                  onChange={(selectedOption) =>
                                    handleUpdatePartDamage(
                                      rowIndex,
                                      "location_damage_id",
                                      selectedOption?.value || null,
                                    )
                                  }
                                  isSearchable
                                  placeholder={t("select_damage_location_type")}
                                />
                              </td>
                              <td>
                                <ReactStars
                                  size={20}
                                  count={5}
                                  value={data.damage_rating}
                                  onChange={(newRating) =>
                                    handleUpdatePartDamage(
                                      rowIndex,
                                      "damage_rating",
                                      newRating,
                                    )
                                  }
                                  activeColor="#ffd700"
                                  a11y={true}
                                  isHalf={true}
                                  emptyIcon={<i className="bi bi-star" />}
                                  halfIcon={<i className="bi bi-star-half" />}
                                  filledIcon={<i className="bi bi-star-fill" />}
                                />
                              </td>

                              <td>
                                <div className="form-check text-left">
                                  <label className="partsLabel col-form-label ml-2"></label>
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() =>
                                      handleDeletePartDamage(rowIndex)
                                    }
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tabId="photos">
              <div className="col-lg-12">
                <Card className="text-center">
                  <Card.Header className="cardHeader">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="AddPh6">
                        <h6>{t("upload_part_image")}</h6>
                      </div>

                      <div>
                        <button
                          type="button"
                          className="btn btn-block btn-primary"
                          onClick={handleSubmitImage}
                          disabled={isloadingImage}
                          style={{ width: "100px", marginTop: "10px" }}
                        >
                          {isloadingImage ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Uploading...
                            </>
                          ) : (
                            <>
                              Submit <i className="bi bi-check2"></i>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body className="cardBody">
                    <div className="row">
                      <div className="col-lg-12 addPartField">
                        <div
                          className="col-lg-12 addPartField"
                          style={{
                            height: "221px",
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          <label className="partsLabel col-form-label ml-2 Label-my form-label">
                            {t("upload_images")}
                          </label>

                          <div className="input-div">
                            <div className="avatar-upload">
                              <div className="avatar-edit">
                                <input
                                  ref={fileInputRef}
                                  className="inputFile"
                                  type="file"
                                  id="imageuploadAbout"
                                  onChange={handleAboutFileChange}
                                  name="file"
                                  accept=".jpg,.jpeg,.png"
                                  multiple
                                />
                                <label htmlFor="imageuploadAbout"></label>
                              </div>

                              <div className="partImages partImages_mob mt-2 d-flex flex-wrap">
                                {images?.map((file, index) => (
                                  <div
                                    key={index}
                                    className="preview-item"
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                      margin: "5px",
                                    }}
                                  >
                                    <img
                                      onClick={() => toggleEnlarge(index)}
                                      className={`image ${
                                        enlargedIndexes.includes(index)
                                          ? "enlarged"
                                          : ""
                                      }`}
                                      src={previewUrl[index]}
                                      alt={`Preview ${index}`}
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        border: "1px solid",
                                        borderRadius: "5px",
                                        objectFit: "cover",
                                      }}
                                    />

                                    <i
                                      className="editImageBtn bi bi-pen-fill"
                                      style={{
                                        position: "absolute",
                                        top: "5px",
                                        left: "5px",
                                        cursor: "pointer",
                                        color: "blue",
                                        backgroundColor: "white",
                                        borderRadius: "50%",
                                        padding: "2px",
                                        zIndex: 2,
                                      }}
                                      onClick={() => handleImageSelect(file)}
                                    ></i>

                                    <i
                                      className="removeImageBtn bi bi-x"
                                      style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        cursor: "pointer",
                                        color: "red",
                                        backgroundColor: "white",
                                        borderRadius: "50%",
                                        padding: "2px",
                                        zIndex: 2,
                                      }}
                                      onClick={() =>
                                        handleRemoveFile(index, file.id)
                                      }
                                    ></i>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </TabPane>
            <TabPane tabId="videos">
              <div className="col-lg-12">
                <Card>
                  <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="AddPh6">
                        <h6>{t("upload_part_video")}</h6>
                      </div>

                      <div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-block btn-primary"
                            onClick={handleSubmitVideo}
                            disabled={isloadingVideo}
                            style={{ width: "100px", marginTop: "10px" }}
                          >
                            {isloadingVideo ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-1"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Uploading...
                              </>
                            ) : (
                              <>
                                Submit <i className="bi bi-check2"></i>
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>{" "}
                  </Card.Header>
                  <Card.Body>
                    <input
                      type="file"
                      accept="video/*"
                      multiple
                      onChange={handleFileChange}
                      ref={(ref) => (fileInputRefs.current = ref)}
                      className="form-control"
                    />

                    <div className="d-flex flex-wrap mt-3">
                      {videos?.map((video, index) => {
                        return (
                          <>
                            <div
                              className="position-relative m-2"
                              style={{ width: "200px" }}
                            >
                              <button
                                className="btn btn-danger btn-sm position-absolute"
                                style={{
                                  top: "5px",
                                  right: "5px",
                                  cursor: "pointer",
                                  zIndex: 10,
                                }}
                                type="button"
                                onClick={() =>
                                  handleRemoveVideo(index, video.id)
                                }
                              >
                                ✖
                              </button>
                              <video width="200" controls>
                                <source
                                  src={
                                    video.url ||
                                    (video.file &&
                                      URL.createObjectURL(video.file))
                                  }
                                  type="video/mp4"
                                />
                              </video>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </Card.Body>
                </Card>
              </div>{" "}
            </TabPane>
          </TabContent>
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handlePartCheckModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalOcrRef} size="xl">
        <ModalHeader>{`OCR Multiple Reference`}</ModalHeader>
        <ModalBody>
          <div className="row align-items-center">
            <div className="col-md-8">
              <FormGroup>
                <Label className="col-form-label">{t("select_file")}</Label>
                <div className="col-xl-12">
                  <div className="input-div">
                    <input
                      className="form-control"
                      type="file"
                      onChange={(e) => setFile(e.target.files[0])}
                      name="file"
                      accept="image/*"
                    />
                    {errorsImport.file && (
                      <span className="input-error">{errorsImport.file}</span>
                    )}
                  </div>
                </div>
              </FormGroup>
            </div>

            <div className="col-md-4">
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={handleSubmitOCRRef}
                style={{ marginTop: "25px" }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>{" "}
                    Processing...
                  </>
                ) : (
                  <>
                    Add References Text <i className="bi bi-check2"></i>
                  </>
                )}
              </button>
            </div>
          </div>
          <div className="row">
            <div
              className="col-md-12"
              style={{
                height: "500px",
                overflow: "scroll",
              }}
            >
              <div className="col-md-12">
                <FormGroup>
                  {/* <div style={{ maxHeight: "300px", overflowY: "auto" }}> */}
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>{t("reference_text")}</th>
                          <th>{t("reference_type")}</th>
                          <th>{t("condition")}</th>
                          <th>{t("action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {refReadData?.length > 0 ? (
                          refReadData.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    updatedTexts[index] !== undefined
                                      ? updatedTexts[index]
                                      : item.text
                                  }
                                  onChange={(e) =>
                                    handleTextChange(index, e.target.value)
                                  }
                                />
                              </td>

                              <td>
                                <Select
                                  className="my-Select"
                                  options={referenceList}
                                  value={
                                    selectedReferenceType[index] ||
                                    referenceList.find((r) => r.value === 2) ||
                                    null
                                  }
                                  onChange={(selectedOption) =>
                                    handleReferenceChangeOcr(
                                      index,
                                      selectedOption,
                                    )
                                  }
                                  isSearchable
                                  placeholder={t("select_reference_type")}
                                />
                              </td>

                              <td>
                                <Select
                                  className="my-Select"
                                  options={conditionList}
                                  value={selectedConditions[index] || null}
                                  onChange={(selectedOption) =>
                                    handleConditionChangeOcr(
                                      index,
                                      selectedOption,
                                    )
                                  }
                                  isSearchable
                                  placeholder={t("select_condition")}
                                />
                              </td>

                              <td>
                                <input
                                  style={{
                                    marginLeft: "100px",
                                    width: "20px",
                                    height: "20px",
                                    accentColor: "black",
                                    marginTop: "-9px",
                                  }}
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={!!selectedRows[index]}
                                  onChange={() => handleCheckboxChange(index)}
                                />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" style={{ textAlign: "center" }}>
                              No record found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* </div> */}
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-secondary"
            onClick={handleChangeOCRClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleChangeOCRClose}
            style={{ width: "156px", marginTop: "10px" }}
          >
            Save References <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalRefCodeCondition} size="xl">
        <ModalHeader>{`Part Details`}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped align-middle">
                      <thead className="table-dark">
                        <tr>
                          <th>{t("ref_code")}</th>
                          <th>Price1 Min</th>
                          <th>Price1 Avg</th>
                          <th>Price1 Max</th>
                          <th>Price2 Min</th>
                          <th>Price2 Avg</th>
                          <th>Price2 Max</th>
                          {/* <th>View</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {refCodeConditionDataList?.partsList?.map(
                          (part, index) => (
                            <tr key={index}>
                              <td>
                                <strong>{part.ref_code}</strong>
                              </td>
                              <td>€ {part?.prices?.price1_min || 0}</td>
                              <td>€ {part?.prices?.price1_avg || 0}</td>
                              <td>€ {part?.prices?.price1_max || 0}</td>
                              <td>€ {part?.prices?.price2_min || 0}</td>
                              <td>€ {part?.prices?.price2_price_avg || 0}</td>
                              <td>€ {part?.prices?.price2_price_max || 0}</td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCloseRefCodeCondition}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalRefCodeEstimate} size="xl">
        <ModalHeader>{`Estimate Price`}</ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>{t("reference")}</th>
                          <th>{t("reference_type")}</th>

                          <th>{t("price_avg")}</th>
                          <th>{t("price_max")}</th>
                          <th>{t("price_min")}</th>
                          <th>{t("quantity")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {estimatePricDataRefList?.stats_for_references?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{item?.reference}</td>
                              <td>{item?.referenceType}</td>
                              <td>€ {item?.stats_reference?.price_avg}</td>
                              <td>€ {item?.stats_reference?.price_max}</td>
                              <td>€ {item?.stats_reference?.price_min}</td>
                              <td>{item?.stats_reference?.quantity}</td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCloseRefCodeEstimate}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={partEtaiModify}>
        <ModalHeader>{`Reference Code`}</ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>{t("reference_code")}</th>
                        <th>{t("product_label")}</th>
                        <th>{t("action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {partETAIRefDetails?.length > 0 ? (
                        partETAIRefDetails.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.reference_code}</td>
                            <td>{item?.product_label}</td>
                            <td>
                              <input
                                type="radio"
                                className="form-check-input"
                                name="radio-select"
                                checked={
                                  selectedReferenceCode === item?.reference_code
                                }
                                onChange={() =>
                                  handleRadioChange(item?.reference_code)
                                }
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" style={{ textAlign: "center" }}>
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handlePartEtaiClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Submit <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modifyOemModal} size="xxl">
        <ModalHeader>{t("oem_references")}</ModalHeader>
        <div className="col-md-6">
          {t("priceOEM")} : € {structureOemList?.decode?.priceOEM || 0}
        </div>
        <ModalBody>
          <div className="d-flex justify-content-between align-items-center">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeOemTab === "1" ? "active" : ""}
                  onClick={() => toggleOemTab("1")}
                  style={{ cursor: "pointer" }}
                >
                  {t("equivalentsIAM")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeOemTab === "2" ? "active" : ""}
                  onClick={() => toggleOemTab("2")}
                  style={{ cursor: "pointer" }}
                >
                  {t("equivalentsOEM")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeOemTab === "3" ? "active" : ""}
                  onClick={() => toggleOemTab("3")}
                  style={{ cursor: "pointer" }}
                >
                  {t("VehiclesCompatibles")}
                </NavLink>
              </NavItem>
            </Nav>
          </div>

          {loadingStructureOem ? (
            <div className="text-center my-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <TabContent activeTab={activeOemTab} className="pt-3">
              <TabPane tabId="1">
                <div className="row">
                  <div
                    className="col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleOpenProductConfirm}
                      style={{
                        width: "110px",
                        marginBottom: "9px",
                        marginTop: "-25px",
                      }}
                    >
                      {t("products")} <i className="bi bi-check2"></i>
                    </button>
                  </div>
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    structureOemList?.decode?.equivalentsIAM
                                      ?.length > 0 &&
                                    selectedVehicleData?.iem_list?.length ===
                                      structureOemList?.decode?.equivalentsIAM
                                        ?.length
                                  }
                                  onChange={handleCheckAll}
                                />
                              </th>
                              <th>{t("brandName")}</th>
                              <th>{t("fullReference")}</th>
                              <th>{t("manufacter")}</th>
                              <th>{t("reference")}</th>
                              <th>{t("action")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {structureOemList?.decode?.equivalentsIAM?.length >
                            0 ? (
                              structureOemList?.decode?.equivalentsIAM?.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={selectedVehicleData?.iem_list?.some(
                                          (i) => i.productID === item.productID,
                                        )}
                                        onChange={() =>
                                          handleCheck(item.productID)
                                        }
                                      />
                                    </td>
                                    <td>{item?.brandName}</td>
                                    <td>{item?.fullReference}</td>
                                    <td>{item?.manufacter}</td>
                                    <td>{item?.reference}</td>
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-block btn-primary"
                                        onClick={(e) => {
                                          setProductVehicleId(item);
                                          setModifyProductModal(true);
                                        }}
                                        style={{
                                          width: "45px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        <i className="bi bi-eye-fill"></i>{" "}
                                      </button>{" "}
                                    </td>
                                  </tr>
                                ),
                              )
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="2">
                <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    structureOemList?.decode?.equivalentsOEM
                                      ?.length > 0 &&
                                    selectedVehicleData?.oem_list?.length ===
                                      structureOemList?.decode?.equivalentsOEM
                                        ?.length
                                  }
                                  onChange={handleCheckAllOEM}
                                />
                              </th>
                              <th>{t("manufacter")}</th>
                              <th>{t("fullReference")}</th>
                              <th>{t("reference")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {structureOemList?.decode?.equivalentsOEM?.length >
                            0 ? (
                              structureOemList?.decode?.equivalentsOEM?.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={selectedOEMIndices.includes(
                                          index,
                                        )}
                                        onChange={() => handleCheckOEM(index)}
                                      />
                                    </td>
                                    <td>{item?.manufacter}</td>
                                    <td>{item?.fullReference}</td>
                                    <td>{item?.reference}</td>
                                  </tr>
                                ),
                              )
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="3">
                <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    structureOemList?.decode?.equivalentsOEM
                                      ?.length > 0 &&
                                    selectedOEMIndices.length ===
                                      structureOemList.decode.equivalentsOEM
                                        .length
                                  }
                                  onChange={handleCheckAllOEM}
                                />
                              </th>
                              <th>{t("vehicle_make_description")}</th>
                              <th>{t("vehicle_model_description")}</th>
                              <th>{t("vehicle_variant_description")}</th>
                              <th>{t("vehicle_variant_end_production")}</th>
                              <th>{t("vehicle_variant_init_production")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {vehicleCompatiblesList?.length > 0 ? (
                              vehicleCompatiblesList?.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedVehicleData?.vehicle_compatible_list?.some(
                                        (i) => i.variantID === item.variantID,
                                      )}
                                      onChange={() =>
                                        handleCompatibleCheck(item.variantID)
                                      }
                                    />
                                  </td>
                                  <td>{item?.vehicle_make_description}</td>
                                  <td>{item?.vehicle_model_description}</td>
                                  <td>{item?.vehicle_variant_description}</td>
                                  <td>
                                    {item?.vehicle_variant_end_production}
                                  </td>
                                  <td>
                                    {item?.vehicle_variant_init_production}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleSelectRef}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("Select")} <i className="bi bi-check2"></i>
          </button>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleChangeOemRefClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modifyConfirmModal}>
        <ModalHeader>{t("replace_the_vehicle_compatibles")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("are_you_sure_you_want_to_replace_the_vehicle_compatibles_data")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleProductConfirmClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("No")} <i className="bi bi-x-lg"></i>
          </button>

          {!loadingCompatible && (
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px" }}
              onClick={handleSubmitVehicleComProduct}
            >
              {t("yes")} <i className="bi bi-x-lg"></i>
            </button>
          )}
          {loadingCompatible && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>
      <Modal isOpen={modifyProductModal} size="xxl">
        <ModalHeader>{t("product_details")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div
                    className="row"
                    style={{
                      marginTop: "10px",
                    }}
                  >
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("product_name")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("reference")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.reference || "-"}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("supplier")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.supplier || "-"}
                      </h6>
                    </div>

                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("eanNumbers")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product?.eanNo
                          ?.eanNumbers || 0}
                      </h6>
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                  </div>

                  <div className="row">
                    <div className="col-md-6" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("allSpecifications")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("criteriaName")}</th>
                                <th>{t("criteriaValue")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.allSpecifications?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.allSpecifications?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.criteriaName}</td>
                                      <td>{item?.criteriaValue}</td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("crossOEM")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("fullReference")}</th>
                                <th>{t("manufacter")}</th>
                                <th>{t("reference")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.crossOEM?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.crossOEM?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.fullReference}</td>
                                      <td>{item?.manufacter}</td>
                                      <td>{item?.reference}</td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("vehiclesCompatibles")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("vehicle_make_description")}</th>
                                <th>{t("vehicle_model_description")}</th>
                                <th>{t("vehicle_variant_description")}</th>
                                <th>{t("vehicle_variant_end_production")}</th>
                                <th>{t("vehicle_variant_init_production")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.vehiclesCompatibles?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.vehiclesCompatibles?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.vehicle_make_description}</td>
                                      <td>{item?.vehicle_model_description}</td>
                                      <td>
                                        {item?.vehicle_variant_description}
                                      </td>
                                      <td>
                                        {item?.vehicle_variant_end_production}
                                      </td>
                                      <td>
                                        {item?.vehicle_variant_init_production}
                                      </td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleProductDetailsModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={isModalOpen} toggle={closeModal} size="lg">
        <Form method="post">
          <ModalHeader toggle={closeModal}>{t("image_edit")}</ModalHeader>
          {selectedImage && (
            <ModalBody>
              <div className="modal-body" style={{ marginBottom: "100px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "400px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                      height: "394px",
                    }}
                  >
                    <ReactCrop
                      crop={crop}
                      onImageLoaded={onImageLoad}
                      onChange={(newCrop) => setCrop(newCrop)}
                      onComplete={(c) => setCompletedCrop(c)}
                      disabled={!isCropping}
                    >
                      <img
                        src={selectedImage.image_url}
                        ref={imgRef}
                        style={{
                          transform: `rotate(${rotation}deg)`,
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "cover",
                          height: "394px",
                          display: selectedImage ? "block" : "none",
                        }}
                        alt="Crop preview"
                        onClick={onImageClick}
                      />
                    </ReactCrop>
                    {isDrawing && !isCropping && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <ReactSketchCanvas
                          ref={canvasRef}
                          style={{
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                          }}
                          canvasColor="transparent"
                          allowOnlyPointerType="all"
                        />
                      </div>
                    )}
                  </div>

                  <div className="row" style={{ marginTop: "40px" }}>
                    <div className="col-md-2">
                      <i
                        className="bi bi-crop"
                        style={{
                          fontSize: "22px",
                          cursor: "pointer",
                          color: isCropping ? "blue" : "black",
                        }}
                        onClick={handleCrop}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-brush"
                        style={{
                          fontSize: "22px",
                          cursor: "pointer",
                          color: isDrawing ? "blue" : "black",
                        }}
                        onClick={() => saveDrawing(selectedImage.id)}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-arrow-counterclockwise"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={() => handleRotate(selectedImage.id)}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-image"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={() =>
                          handleRemoveBgImageeForm(selectedImage.id)
                        }
                        disabled={isLoading}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-image"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={(e) => handleAddBgImageForm(selectedImage.id)}
                        disabled={isLoadings}
                      ></i>
                    </div>

                    <div className="col-md-2">
                      <i
                        className="bi bi-paint-bucket"
                        style={{ fontSize: "22px", cursor: "pointer" }}
                        onClick={() => handleAddBgColoreForm(selectedImage.id)}
                      ></i>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-2">
                      <span>{t("crop")}</span>
                    </div>

                    <div className="col-md-2">
                      <span>{t("brush")}</span>
                    </div>

                    <div className="col-md-2">
                      <span>{t("rotate")}</span>
                    </div>

                    <div className="col-md-2">
                      <span>{isLoading ? "Processing..." : "Remove Back"}</span>
                    </div>

                    <div className="col-md-2">
                      <span> {isLoadings ? "Processing..." : "Add Back"}</span>
                    </div>

                    <div className="col-md-2">
                      <span>
                        {isLoadingColor ? "Processing..." : "Add Color"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ModalBody>
          )}

          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={getCroppedImage}
            >
              Apply Changes
            </button>
          </ModalFooter>
        </Form>
      </Modal>
      <Modal isOpen={isModalVideoDelete} toggle={handleDeleteClose}>
        <ModalHeader toggle={handleDeleteClose}>{t("delete_video")}</ModalHeader>
        <ModalBody>
          <div>{"Are you sure you want to delete this video?"}</div>
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleDeleteClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")}
          </button>

          <button
            type="button"
            className="btn btn-block bg-red"
            style={{ width: "100px" }}
            onClick={handleEditRemoveVideo}
          >
            {t("delete")}
          </button>
        </ModalFooter>
      </Modal>{" "}
      <Modal isOpen={modifyConvert} toggle={handleConvertClose}>
        <ModalHeader toggle={handleConvertClose}>{t("convert_part")}</ModalHeader>
        <ModalBody>
          <div>{"Are you sure you want to convert this part?"}</div>
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleConvertClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")}
          </button>

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "100px" }}
            onClick={handleConvertPart}
          >
            Convert
          </button>
        </ModalFooter>
      </Modal>{" "}
      <Modal isOpen={modalStateRefHistory} size="lg">
        <ModalHeader>{`Part Details`}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>{t("id")}</th>
                        <th>{t("part_name")}</th>
                        <th>{t("make")}</th>
                        <th>{t("modal")}</th>
                        <th>{t("variant")}</th>
                        <th>{t("year")}</th>
                        <th>{t("quantity")}</th>
                        <th>{t("price")}</th>
                        <th>{t("createdDate")}</th>
                        <th>{t("action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {catalogModalStateRefDataList?.length > 0 ? (
                        catalogModalStateRefDataList.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.id}</td>
                            <td>{item?.part_name}</td>
                            <td>{item?.make_name}</td>
                            <td>{item?.model_name}</td>
                            <td>{item?.variant_name}</td>
                            <td>{item?.vehicle_year}</td>
                            <td>{item?.quantity}</td>
                            <td>€ {item?.part_price}</td>
                            <td>
                              {moment(item?.created_at).format(
                                "DD/MM/YYYY HH:mm",
                              )}
                            </td>
                            <td>
                              <div
                                style={{ cursor: "pointer" }}
                                className="edit-btn"
                                onClick={() =>
                                  window.open(
                                    `/part-details/${item.uuid}`,
                                    "_blank",
                                  )
                                }
                              >
                                <i className="bi bi-eye-fill"></i>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center text-muted">
                            No reference part data available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleClosePartRefHistory}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalPartDetails} size="lg">
        <ModalHeader>{`Part Details`}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div className="row">
                    <div className="col-md-6">
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "5px",
                          fontSize: "16px",
                          fontWeight: "500",
                          marginBottom: "10px",
                        }}
                      >
                        Part Catalog Name : {partAddDetails?.part_catalog_name}
                      </span>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <h5>{t("parts_reference")}</h5>

                      <div
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          overflowX: "auto",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                        }}
                      >
                        <table className="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>{t("reference_code")}</th>
                              <th>{t("type_name")}</th>
                              <th>{t("condition_name")}</th>
                              <th>{t("reference_parts_count")}</th>
                              <th>{t("is_main")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partAddDetails?.parts_check_reference?.length >
                            0 ? (
                              partAddDetails.parts_check_reference.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>{item?.reference_code}</td>
                                    <td>{tConst(item?.type_name, t)}</td>
                                    <td>{tConst(item?.condition_name, t)}</td>
                                    <td>{item?.reference_parts_count}</td>
                                    <td>
                                      {item?.is_main === 1 ? "Yes" : "No"}
                                    </td>
                                  </tr>
                                ),
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan="10"
                                  className="text-center text-muted"
                                >
                                  No reference part data available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <h5>{t("parts_damage")}</h5>

                      <div
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          overflowX: "auto",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                        }}
                      >
                        <table className="table table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>{t("damage_name")}</th>
                              <th>{t("damage_description")}</th>
                              <th>{t("type_damage_name")}</th>
                              <th>{t("damage_rating")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partAddDetails?.parts_damage?.length > 0 ? (
                              partAddDetails.parts_damage.map((item, index) => (
                                <tr key={index}>
                                  <td>{tConst(item?.location_damage_name, t)}</td>
                                  <td>{item?.damage_description}</td>
                                  <td>{tConst(item?.type_damage_name, t)}</td>
                                  <td>{item?.damage_rating}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="10"
                                  className="text-center text-muted"
                                >
                                  No damage part data available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {partAddDetails?.image_list?.length > 0 && (
                    <div className="row">
                      <div className="col-md-12">
                        <h5>{t("parts_image")}</h5>

                        <div className="row justify-content-start">
                          {partAddDetails?.image_list?.map((image) => {
                            return (
                              <>
                                <div className="col-sm-3">
                                  <div className="column-img">
                                    <img src={image?.image_url} alt="" />
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}

                  {partAddDetails?.video_list?.length > 0 && (
                    <div className="row">
                      <div className="col-md-12">
                        <h5>{t("parts_video")}</h5>

                        <div className="row justify-content-start">
                          {partAddDetails?.video_list?.map((items) => {
                            return (
                              <>
                                <div className="col-sm-3">
                                  <div className="column-img">
                                    <video
                                      src={items.video_url}
                                      width="200"
                                      controls
                                      style={{
                                        borderRadius: "5px",
                                        margin: "5px",
                                      }}
                                    >
                                      Your browser does not support the video
                                      tag.
                                    </video>
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handlePartDetailsClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PartsCheck;
